import { acknowledgeNotification } from '../../../../services/NotificationService';

import './NotificationModal.css';

export const NotificationModal = ({
  notifications,
  onClose,
  setSpinnerText,
  showToaster,
  context,
  onAcknowledgeSuccess,
  setContext,
}) => {
  const navigateFromNotification = async (notification) => {
    switch (notification.contextType) {
      case 'Study':
        const [studyExternalReference, facilityExternalReference] = notification.contextReference.split('$');
        setContext((prevState) => ({
          ...prevState,
          currentScreen: 'studyTrialEdit',
          activeTab: 'studyTrialEditGeneral',
          viewStack: [...prevState.viewStack, prevState.currentScreen],
          additionalContext: { studyExternalReference, facilityExternalReference },
        }));
        break;
      case 'Review':
        setContext((prevState) => ({
          ...prevState,
          currentScreen: 'participantReviewsEdit',
          activeTab: 'participantReviewCreateGeneral',
          viewStack: [...prevState.viewStack, prevState.currentScreen],
          additionalContext: { reviewExternalReference: notification.contextReference },
        }));
        break;
      case 'Query':
        setContext((prevState) => ({
          ...prevState,
          currentScreen: 'participantReviewsEdit',
          activeTab: 'participantReviewCreateQuery',
          viewStack: [...prevState.viewStack, prevState.currentScreen],
          notification,
        }));
        break;
      case 'CAPA':
        setContext((prevState) => ({
          ...prevState,
          currentScreen: 'capaReviewsEdit',
          activeTab: 'capaReviewCreateGeneral',
          viewStack: [...prevState.viewStack, prevState.currentScreen],
          additionalContext: { externalReference: notification.contextReference },
        }));
        break;
      case 'Participant':
        setContext((prevState) => ({
          ...prevState,
          currentScreen: 'participantEdit',
          activeTab: undefined,
          viewStack: [...prevState.viewStack, prevState.currentScreen],
          additionalContext: { participantExternalReference: notification.contextReference },
        }));
        break;
      default:
    }
  };

  const handleNotificationClick = async (event, notification) => {
    event.stopPropagation();
    if (!notification.acknowledged) {
      setSpinnerText('Acknowledging Notification');
      const [data, error] = await acknowledgeNotification(context.username, notification.externalReference);
      if (data) {
        if (data.responseStatus === 'Success') {
          await onAcknowledgeSuccess();
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    }

    navigateFromNotification(notification);
  };

  const renderSection = (title, acknowledged) => {
    const filteredNotifications = notifications.filter((notification) => notification.acknowledged === acknowledged);

    if (filteredNotifications.length === 0) return null;

    return (
      <div className="notification-modal-section">
        <p className="notification-modal-section-heading" onClick={(event) => event.stopPropagation()}>
          {title}
        </p>
        {filteredNotifications.map((notification) => {
          return (
            <button
              key={notification.externalReference}
              className={`notification-modal-notification ${notification.acknowledged ? 'acknowledged' : ''}`}
              onClick={(event) => handleNotificationClick(event, notification)}
            >
              <p
                className={`notification-modal-notification-message ${notification.acknowledged ? 'acknowledged' : ''}`}
              >
                {notification.message}
              </p>
              <p className="notification-modal-notification-date">{notification.creationDate}</p>
            </button>
          );
        })}
      </div>
    );
  };

  return (
    <article className="notification-modal-background" onClick={onClose}>
      <div className="notification-modal">
        {renderSection('Unread Notifications', false)}
        {renderSection('Read Notifications', true)}
        {notifications.length === 0 && <p className="notification-modal-empty-message">No Notifications</p>}
      </div>
    </article>
  );
};
